import { QueryClient } from "@tanstack/react-query";

/** Singleton so the auth store can clear it on logout. */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 15_000, retry: 1, refetchOnWindowFocus: false },
  },
});
